// custom datatble message for empty
DATATABLE_LANGUAGE_OPTIONS = {
    "sEmptyTable": "No Record Available",
    "sLengthMenu": "Show _MENU_ Records",
    "sInfo": "Showing _START_ to _END_ of _TOTAL_ records",
    "sInfoEmpty": "Showing 0 to 0 of 0 records",
    "search": "Search"
};
DATATABLE_MENU_LENGTH_OPTIONS = [25, 50, 100];
DROPDOWN_MULTI_SELECT_PLACEHOLDER = 'Select option(s)';
DROPDOWN_SINGLE_SELECT_PLACEHOLDER = 'Select option';
SEARCH = 'Search';
DATE_FORMAT = 'd.m.Y';
DATE_FORMAT_GUEST = 'DD.MM.YYYY';
DATE_TIME_FORMAT = 'd.m.Y H:i';
DATE_TIME_FORMAT_GUEST = 'DD.MM.YYYY H:i';
WIDGET_SCRIPT_URL = 'http://127.0.0.1:8000/core/widget';
RESERVATION_STATUS = {
    'confirmed': 'Confirmed',
    'seated': 'Seated / Partly seated',
    'checked_out': 'Checked out',
    'not_confirmed': 'Not Confirmed',
    'cancelled': 'Cancelled',
    'no_show': 'No show',
    'rejected': 'Rejected',
    'revoked': 'Revoked'
};
REPORT_TYPE = {
    'guest': 'Guest',
    'reservation': 'Reservation',
    'enquiry': 'Enquiry'
}
RESERVATION_TIME_INVERVAL_HR = '02:30';
MIN_INTERVAL = '15';
DASHBOARD_DATE_FORMAT = 'dddd, D MMMM';
LOCALE = 'en-US';
ENQUIRY_STATUS = {
    'new': 'New',
    'in_progress': 'In progress',
    'accepted': 'Accepted',
    'rejected': 'Rejected',
};

require('jquery-validation');
require('./bootstrap');
require('jquery-clock-timepicker');
require('jquery-ui/ui/widgets/datepicker');
require('inputmask/dist/inputmask');
require('inputmask/dist/jquery.inputmask');
require('@glidejs/glide/dist/glide')
require('select2/dist/js/select2.full.min')
require('jquery-ui-multiselect-widget/src/jquery.multiselect');
require('sweetalert2/dist/sweetalert2.all');
require('./common');
require('./leftSideMenu');
require('./test');
require('./user');
require('./arrival');
require('./reservationphases');
require('./guestTags');
require('./reservationTags');
require('./dailyNotes');
require('./tables');
require('./tablesCombination');
require('./guest');
require('./areas');
require('./availability');
require('./exception');
require('./closingTime');
require('./reservations');
require('spectrum-colorpicker');
require('./widget');
require('./jquery.skedTape');
require('./restaurant');
require('./restaurantPriority');
require('./reports');
require('./restaurantPriority')
require('daterangepicker')
require('./dashboard');
require('jquery-paginate');
require('./enquiry')
require('./schedule')
require('./retentiontime');
require('./owner');
require('./password');
require('./jquery.richtext');
require('./exceptionOpening');
require('./generalsettings');
require('./pageLeaveAlert');
require('./data');